import {h, type FunctionalComponent} from '@stencil/core';
import type {IDashboardDesktopView} from '../dashboard-desktop-view';
import {DashboardItemHeader} from '../../dashboard-item-header/dashboard-item-header';

interface FaqDashboardWidgetProps extends Pick<IDashboardDesktopView,
  'faqData'| 'isOffsitesVisible' | 'offsiteBannersManagerRequestData' | 'hasCtaProductSelector' | 'country' | 'language' | 'rtl' | 'query' | 'isDashboardView' | 'tabName' | 'labelProvider' > { targetTab: string; tabCount: number;
}




export const FaqDashboardWidget:FunctionalComponent<FaqDashboardWidgetProps > = (props) => {
    const {faqData, isOffsitesVisible, offsiteBannersManagerRequestData, hasCtaProductSelector, country,language, rtl, query, isDashboardView, tabName, labelProvider, targetTab, tabCount } = props;
    return faqData ?
      <div
        class={{
          'dashboard--full-width': faqData.length > 0,
          dashboard__faq: faqData.length > 0,
          'order-0':
          (!isOffsitesVisible || !offsiteBannersManagerRequestData) &&
          !hasCtaProductSelector,
        }}
      >
        <uiaas-search-widget-faq
          country={country}
          language={language}
          rtl={rtl}
          maxItems={3}
          termAttribute={query}
          dashboardSearcherData={faqData}
          isDashboardView={isDashboardView}
          app-name="support"
          tab-name={tabName}
          labelProvider={(e, f) => labelProvider(e, f)}
        >
          <div slot="dashboard-section-header">
            <DashboardItemHeader
              itemCount={faqData.length}
              labelProvider={(e, f) => labelProvider(e, f)}
              tabCount={tabCount}
              targetTab={targetTab}
              title=''
              term={query}
              subTitle={true}
            />
          </div>
        </uiaas-search-widget-faq>
      </div> : '';
};

export default FaqDashboardWidget;
